import React from 'react'
import asideModalStore from 'Stores/asideModalStore'
import FormFieldset from 'components/UI/AsideModal/Form/FormFieldset'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import FormField from 'components/UI/AsideModal/Form/FormField'
import './AddNewTemplates.scss'
import Textarea from 'components/ContentBox/Global/Textarea/Textarea'
import useLocalization from 'hooks/useLocalization'

const AddNewTemplates = () => {
  const { modalValues, changeValue, check } = asideModalStore

  const { translate } = useLocalization({
    section: 'crm',
    subsection: 'crm_event',
    dict: {
      template_name: 'Template name',
      enter_template_text: 'Enter template text',
    },
  })

  return (
    <FormFieldset>
      <FormField>
        <FormLabel isRequired>{translate.template_name}:</FormLabel>
        <FormInput isError={check('title')}>
          <input
            placeholder={translate.template_name}
            type='title'
            value={modalValues.title || ''}
            onChange={(e) => changeValue(e.target.value, 'title')}
          />
        </FormInput>
      </FormField>
      <FormField>
        <FormLabel isRequired>{translate.enter_template_text}:</FormLabel>
        <Textarea
          onChange={changeValue}
          stateName='content'
          error={check('content')}
          value={modalValues.content || ''}
          placeholder={translate.enter_template_text}
        />
      </FormField>
    </FormFieldset>
  )
}

export default AddNewTemplates
